
import { Component, Vue } from 'vue-property-decorator'
import type { Route } from 'vue-router'

import { parseRedirectParam, withSellerPrefix } from '@/helpers/route'

@Component({ name: 'Auth0LogoutRoute' })
export default class extends Vue {
  beforeRouteEnter(to: Route, _: Route, next: AnyFn): void {
    const redirect = parseRedirectParam(to.query.redirect)

    next(() => {
      window.location.href = withSellerPrefix(redirect ?? '/')
    })
  }
}
